module.exports = __webpack_public_path__ + "img/miniQrcode.99edb36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/miniQrcode.jpg
// module id = 95wI
// module chunks = 2